// src/universal/extension/communication/index.ts
var notifyExtension = ({ id, type, data }) => {
  if (typeof chrome !== "undefined" && chrome.runtime) {
    chrome.runtime.sendMessage(id, { type, data }, () => {
      var _a;
      if ((_a = chrome.runtime) == null ? void 0 : _a.lastError) {
        console.log("Extension not available");
      }
    });
  }
};

export { notifyExtension };
//# sourceMappingURL=chunk-2AVUNXAY.mjs.map
//# sourceMappingURL=chunk-2AVUNXAY.mjs.map